import { AgCharts } from 'ag-charts-react';
import { AgChartOptions } from 'ag-charts-community';
import useConnectedCashPositionOverview from '../../../../../customhooks/useConnectedCashPositionOverview';


const CashPositionCard = () => {
    const { entries: data = [] } = useConnectedCashPositionOverview();

    const options: AgChartOptions = {
        data,
        series: [
            { type: 'line' as const, xKey: 'month', yKey: 'inflow', yName: 'Inflow' },
            { type: 'line' as const, xKey: 'month', yKey: 'outflow', yName: 'Outflow' },
        ],
        axes: [
            { type: 'number', position: 'left', label: { formatter: ({ value }) => `${value/1_000_000}M`} },
            { type: 'category', position: 'bottom' },
        ]
    }

    return (
        <div className='w-full bg-white border border-appcolorfaintnine rounded-[24px] py-5 px-6 flex flex-col justify-between'>
            <div className='text-gray700 text-[18px] mb-4'>
                Cash Position
            </div>
            <div className='w-full h-full'>
                <AgCharts options={options} />
            </div>
        </div>
    );
};

export default CashPositionCard;
